import { sha256 } from 'js-sha256';

const fetchOptions = {
  credentials: 'include',
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
};

/**
 NOTE: In order to save sent bytes from the client
 this method tries to run a fetch without uploading the
 query itself. If server and client versions differ
 the fetch reruns with query included
* */
const execQuery = async (query, variables, key, main, options) => {
  const payload = {
    release: window.RELEASE,
    version: window.GRAPHQL_VERSION,
    variables,
    key,
    main,
    query,
  };

  if (window.USE_BFF_SERVICE) {
    try {
      const res = await fetch(window.BFF_API_URL, {
        ...fetchOptions,
        method: 'POST',
        body: JSON.stringify({
          query: `hash:${sha256(query)}`,
          variables,
        }),
      });
      const json = await res.json();
      if (res.status === 200 && !json.errors?.length) {
        return json;
      }
      if (res.status === 418) {
        return location.reload();
      }

      // If no success, try again with query
      return await fetch(window.BFF_API_URL, {
        ...fetchOptions,
        method: 'POST',
        body: JSON.stringify({
          query,
          variables,
        }),
      }).then(x => x.json());
    } catch (error) {
      const graphqlError = new error.constructor(
        `GraphQL Fetch Error: ${error.message}`
      );

      if (error.stack) {
        graphqlError.stack = error.stack;
      }

      throw graphqlError;
    }
  }

  if (!main) {
    // If request is not succesfull, rerun the request with the query included
    return fetch(`/_internal/graphql`, {
      ...fetchOptions,
      ...options,
      body: JSON.stringify(payload),
    }).then(x => x.json());
  }

  // Make first request without query
  return fetch(
    `/_internal/graphql?release=${encodeURIComponent(payload.release)}${
      payload.version ? `&version=${payload.version}` : ''
    }&main=${main}&variables=${encodeURIComponent(JSON.stringify(variables))}`,
    {
      ...fetchOptions,
      ...options,
      method: 'GET',
      headers: {},
    }
  )
    .then(res => {
      if (res.status === 200) {
        return res.json();
      }

      if (res.status === 418) {
        return location.reload();
      }

      // If request is not succesfull, rerun the request with the query included
      return fetch(`/_internal/graphql`, {
        ...fetchOptions,
        ...options,
        body: JSON.stringify({ ...payload, query }),
      }).then(x => x.json());
    })
    .catch(error => {
      const graphqlError = new error.constructor(
        `GraphQL Fetch Error: ${error.message}`
      );

      if (error.stack) {
        graphqlError.stack = error.stack;
      }

      throw graphqlError;
    });
};

export default execQuery;
